<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <p>{{priorAnswer}}</p>
  <div _ngcontent-c5="" class="col-sm-5 m-auto">
      <label class="card card-list w-100 pt-2 text-center d-inline-block" for="Self-Selected Switch">
          <div></div>
          <label for="Self-Selected Switch">Self-Selected Switch</label>
          <p>{{prevDate}}</p>
          <div class="d-flex flex-wrap">
          <div class="offset-md-3 col-3 pull-left pt-1 pr-0">edit date</div>
          <div class="col-6 pull-left text-left pl-0">
            <my-date-picker name="mydate" class="date-format" required [options]="myDatePickerOptions" id ="date"
            [(ngModel)]="datemodel" (ngModelChange)="dateChanged();" placeholder = "MM/DD/YYYY" required></my-date-picker>
          </div>
        </div>
      </label>
  </div>
  <button class="btn next mr-2 ml-2 sectbtn mt-4 font22 text-uppercase" (click)="next();">Next</button>
</div>
<div class="container mobileview mt-2 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="col-sm-12 m-auto">
    <div class="col-12 form-group px-0">
      <label class="card card-list w-100 pt-2 text-center d-inline-block" for="Self-Selected Switch">
        <div></div>
        <label for="Self-Selected Switch">Self-Selected Switch</label>
        <p>{{prevDate}}</p>
        <my-date-picker name="mydate" class="date-format" required [options]="myDatePickerOptions" id="date" [(ngModel)]="datemodel"
          (ngModelChange)="dateChanged();" placeholder="MM/DD/YYYY" required></my-date-picker>
      </label>
    </div>
    <div style="width:96% !important; text-align: right;">
    <div *ngIf="user_bot" class="ash_box text-right mt-2" >
      <h1 class="ansMob text-right">{{ans_conf_date}}</h1>
    </div>
    </div>
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center">
    <span><img src="assets/images/active6.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
</div> -->